export default "__VITE_ASSET__a15cb35d__"